import { useMemo } from 'react';
import { useAssetPrices, useAssetsIcons } from '@/shared/api';
import { ASSET_PRICES_FILTER } from '@/shared/types';
import {
  MARKET_BASE_ASSET,
  toMarketAsset,
  type MarketAsset,
} from '@/widgets/market-assets';

const useMarketsSearchAssets = () => {
  const { assetsIconsData } = useAssetsIcons();
  const { data, isLoading } = useAssetPrices({
    asset: MARKET_BASE_ASSET,
    filter: ASSET_PRICES_FILTER.all,
  });

  const assets: Array<MarketAsset> = useMemo(() => {
    if (!data) return [];

    return data.assets.map(asset =>
      toMarketAsset(asset, data.basePrecission, assetsIconsData?.value)
    );
  }, [data, assetsIconsData]);

  return { assets, baseAsset: MARKET_BASE_ASSET, isLoading };
};

export { useMarketsSearchAssets };
